export enum THEMES {
  DEFAULT = "DEFAULT",
  // Get the name from the design
  "02" = "02",
}

export type SectionConfig = {
  bg?: string;
  color?: string;
  weight?: string;
};

export type ThemeConfigurationType = {
  [key in THEMES]: {
    BODY_BG: string;
    FOOTER_BG: string;
    FONT_FAMILY: string;
    STYLE_SHEETS: string;
    NAV: SectionConfig;
  };
};
